import { SubmitFormButton, TextField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Popup as CuiPopup, Footer as CuiFooter } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { forwardRef } from 'react';
const fieldCss = "fks2myy";
const Field = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(fieldCss, props.className)} />);
export const Popup = props => <CuiPopup {...props} title={I18n.t('publisher.components.insert_link_popup.edit_link')} />;
export const LinkTextField = () => <Field name="text" label={I18n.t('publisher.components.insert_link_popup.link_text')} />;
export const LinkUrlField = () => <TextField name="url" label={I18n.t('publisher.components.insert_link_popup.link_url')} required />;
export const Footer = ({
  onClose
}) => <CuiFooter>
    <Button decoration="secondary-outline" onClick={onClose}>
      {I18n.t('publisher.action.cancel')}
    </Button>
    <SubmitFormButton>
      {I18n.t('publisher.components.editor.insert')}
    </SubmitFormButton>
  </CuiFooter>;
export { Body } from '@calendly/ui/components/popup';

require("./parts.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./parts.js");